import * as React from 'react'
import { ColumnDef } from '@tanstack/react-table'
import { DataTable } from '@/components/DataTable'
import { useAccountUsers } from '@/features/accounts/api/get-account-users'
import UserActions from '@/features/users/components/UserActions'
// @ts-expect-error JS constants, no types provided
import { CUSTOMERS_USER_ROLES } from '@/features/Customers/customers.constants'

type AccountUserLike = {
    id?: string
    userName?: string
    name?: string
    email?: string
    role?: number | string
    lastLogin?: string | null
}

const columns: ColumnDef<AccountUserLike>[] = [
    {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => {
            const user = row.original as AccountUserLike
            const displayName = (user.userName || user.name || user.email || '—') as string
            return (
                <div className='flex flex-col'>
                    <span className='font-medium'>{displayName}</span>
                    <span className='text-xs text-muted-foreground'>{user.email || '—'}</span>
                </div>
            )
        },
    },
    {
        accessorKey: 'role',
        header: 'Role',
        cell: ({ row }) => {
            const role = row.original.role
            const label = typeof role === 'number'
                ? (CUSTOMERS_USER_ROLES as Record<number, string>)[role] ?? role
                : role
            return <span>{label ?? '—'}</span>
        },
    },
    {
        accessorKey: 'lastLogin',
        header: 'Last Login',
        cell: ({ row }) => {
            const v = (row.original as AccountUserLike).lastLogin
            const d = v ? new Date(v) : null
            return <span>{d ? d.toLocaleString() : '—'}</span>
        },
    },
    {
        header: 'Status',
        cell: ({ row }) => <span>{(row.original as AccountUserLike).lastLogin ? 'Active' : 'Invited'}</span>,
    },
    {
        id: 'actions',
        enableHiding: false,
        header: 'Actions',
        cell: ({ row }) => {
            const user = row.original as AccountUserLike
            return (
                <UserActions
                    user={user}
                />
            )
        },
    },
]

export default function UsersTable({ accountId }: { accountId?: string }) {
    const { data, isLoading, error } = useAccountUsers({ accountId: accountId || '' })

    if (isLoading) return <div>Loading users…</div>
    if (error) return <div className='text-destructive'>Failed to load users.</div>

    return (
        <div className='w-full'>
            <DataTable
                columns={columns}
                data={(data as AccountUserLike[]) ?? []}
                emptyMessage='No users.'
                enablePagination={true}
                initialPageSize={10}
                scrollContainerClassName='max-h-[600px] overflow-auto'
            />
        </div>
    )
}


